import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { getUserCertificates, getUserDetails, getUserSkills } from "../../services/users";

export const useAgentProfileDetails = (userId?: string | null) => {
  const { i18n } = useTranslation();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["Agent", "ProfileData", i18n.language, userId],
    queryFn: () => getUserDetails(userId!),
    enabled: !!userId,
  });

  return { agentInfo: data, isAgentInfoLoading: isLoading, isAgentInfoHasError: isError };
};

export const useAgentProfileSkills = (userId?: string | null) => {
  const { i18n } = useTranslation();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["Agent", "ProfileSkills", i18n.language, userId],
    queryFn: () => getUserSkills(userId!),
    enabled: !!userId,
  });

  return { skillsList: data, isSkillsListLoading: isLoading, isSkillsListHasError: isError };
};

export const useAgentProfileCertificates = (userId?: string | null) => {
  const { i18n } = useTranslation();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["Agent", "AgentCertificates", i18n.language, userId],
    queryFn: () => getUserCertificates(userId!),
    enabled: !!userId,
  });

  return { certificatesList: data, isCertificateListLoading: isLoading, isCertificateListHasError: isError };
};
